import React from 'react';

export const FacebookLogo: React.FC<{}> = () => (
	<g stroke="none" strokeWidth="1" fillRule="evenodd" clipRule="evenodd" fill="currentColor">
		<path className="svgpath" d="M28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 20.9877 5.11957 26.7796 11.8125 27.8299V18.0469H8.25781V14H11.8125V10.9156C11.8125 7.40687 13.9027 5.46875 17.1005 5.46875C18.6323 5.46875 20.2344 5.74219 20.2344 5.74219V9.1875H18.4691C16.73 9.1875 16.1875 10.2668 16.1875 11.3739V14H20.0703L19.4496 18.0469H16.1875V27.8299C22.8804 26.7796 28 20.9877 28 14Z"/>
		<path d="M19.4496 18.0469L20.0703 14H16.1875V11.3739C16.1875 10.2668 16.73 9.1875 18.4691 9.1875H20.2344V5.74219C20.2344 5.74219 18.6323 5.46875 17.1005 5.46875C13.9027 5.46875 11.8125 7.40688 11.8125 10.9156V14H8.25781V18.0469H11.8125V27.8299C12.5254 27.9418 13.2557 28 14 28C14.7443 28 15.4746 27.9418 16.1875 27.8299V18.0469H19.4496Z"
			fill="transparent"
		/>
	</g>
);
